<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div (cdkDragEnded)="dragEnded($event)" cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-window-content restorable-window">
    <div cdkDragHandle class="modal-header">
        <h4 id="manualDesignLabel">Manual design</h4>
        <button (click)="clear()" matDialogClose windeClose>
            <sui-svg-icon icon="cross" />
        </button>
    </div>

    <div class="modal-body">
        <winde-validation-alert [(showAlert)]="showFormValidationAlert" [messageObservable]="alertMessageSubject.asObservable()">
        </winde-validation-alert>

        @if (designConfig) {
            <div class="clr">
                <table aria-describedby="manualDesignLabel" class="table table-borderless-custom manual-design-status-table">
                    @if (historyService.logicalTopology?.layersModeEnabled && historyService.logicalTopology.layers?.length) {
                        <thead>
                            <tr>
                                <th></th>
                                @for (layer of historyService.logicalTopology.layers; track layer) {
                                    <th>{{ layer.getFullName() }}</th>
                                }
                            </tr>
                        </thead>
                    }
                    <tbody>
                        <tr>
                            <td>{{ 'project.manualDesignSteps.p2mp' | translate }}</td>
                            @for (value of designConfig.p2mpDesignCompleted; track i; let i = $index) {
                                @if (
                                    historyService.logicalTopology?.layersModeEnabled ||
                                    (!historyService.logicalTopology?.layersModeEnabled && i === 0)
                                ) {
                                    <td [booleanToConvert]="value" [isDisabled]="!hasNodesMappedToLayer[i]" windeBoolToCheckMark></td>
                                }
                            }
                        </tr>
                        <tr>
                            <td>{{ 'project.manualDesignSteps.designRings' | translate }}</td>
                            @for (value of designConfig.ringDesignCompleted; track i; let i = $index) {
                                @if (
                                    historyService.logicalTopology?.layersModeEnabled ||
                                    (!historyService.logicalTopology?.layersModeEnabled && i === 0)
                                ) {
                                    <td [booleanToConvert]="value" [isDisabled]="!hasNodesMappedToLayer[i]" windeBoolToCheckMark></td>
                                }
                            }
                        </tr>
                        <tr>
                            <td>{{ 'project.manualDesignSteps.autoFrequencies' | translate }}</td>
                            <td [booleanToConvert]="designConfig.frequencyDesignCompleted" windeBoolToCheckMark></td>
                        </tr>
                        <tr>
                            <td>{{ 'project.manualDesignSteps.autoConfigureRings' | translate }}</td>
                            <td [booleanToConvert]="designConfig.ringsConfigCompleted" windeBoolToCheckMark></td>
                        </tr>
                        <tr>
                            <button
                                (click)="clearDesign()"
                                [disabled]="!historyService.isEditModeEnabled"
                                class="btn btn-link btn-sm btn-clean-design"
                            >
                                {{ 'project.manualDesignSteps.clearDesign' | translate }}
                            </button>
                        </tr>
                        <tr>
                            <span>NOTE: all frozen or installed links will be erased</span>
                        </tr>
                        <tr>
                            <button
                                (click)="autoSelectProducts()"
                                [disabled]="!historyService.isEditModeEnabled"
                                class="btn btn-link btn-sm btn-auto-select-products"
                            >
                                {{ 'project.manualDesignSteps.autoSelectProducts' | translate }}
                            </button>
                        </tr>
                        <tr>
                            <button
                                (click)="generateBOM()"
                                [disabled]="
                                    !historyService.logicalTopology.isShowPlanningMode ||
                                    historyService.logicalTopology.isBomStepDisabled ||
                                    !historyService.isEditModeEnabled
                                "
                                class="btn btn-link btn-sm btn-auto-select-products"
                            >
                                {{ 'project.manualDesignSteps.generateBom' | translate }}
                            </button>
                        </tr>
                    </tbody>
                </table>
            </div>
        }

        @if (tabsToShow && tabsToShow.length > 0) {
            <winde-tabs-nav
                (tabChanged)="changeTab($event)"
                [activeTab]="currentTab"
                [customClass]="'tabs-nav--doc-tabs-small mb-4'"
                [tabsList]="tabsToShow"
                [translationPrefix]="'project.manualDesign'"
            >
            </winde-tabs-nav>
        }

        <div class="clr">
            <div class="tab-content pt-0">
                <!-- P2MP DESIGN TAB-->
                @if (currentTab === manualDesignSteps.DESIGN_P2MP) {
                    <div class="tab-pane active" role="tabpanel">
                        <div class="clr">
                            <div class="form-group row justify-content-md-center">
                                @if (historyService.logicalTopology?.layersModeEnabled) {
                                    <div class="col-5">
                                        <div class="d-inline-flex align-middle">
                                            <button
                                                (click)="designPtmp()"
                                                [disabled]="!historyService.isEditModeEnabled"
                                                class="btn btn-sm btn-success btn-small-style btn-design-ptmp"
                                            >
                                                {{ 'project.manualDesignSteps.designPtmp' | translate }}
                                            </button>
                                            <span class="layer-label-text">for layer</span>
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <select
                                            (ngModelChange)="updateReactiveFormForLayer($event)"
                                            [(ngModel)]="p2mpSelectedLayer"
                                            [disabled]="!historyService.isEditModeEnabled"
                                            class="form-control form-control-sm"
                                            id="p2mp_selected_layer"
                                            name="p2mp_selected_layer"
                                        >
                                            @for (layer of historyService.logicalTopology.layers; track layer) {
                                                <option [ngValue]="layer.layerIndex">
                                                    {{ layer.getFullName() }}
                                                </option>
                                            }
                                        </select>
                                    </div>
                                }
                                @if (!historyService.logicalTopology?.layersModeEnabled) {
                                    <div class="col-10">
                                        <button
                                            (click)="designPtmp()"
                                            [disabled]="!historyService.isEditModeEnabled"
                                            class="btn btn-sm btn-success btn-small-style btn-design-ptmp"
                                        >
                                            {{ 'project.manualDesignSteps.designPtmp' | translate }}
                                        </button>
                                    </div>
                                }
                            </div>
                            @if (historyService.logicalTopology?.layersModeEnabled) {
                                <hr />
                            }
                        </div>
                        <!--P2MP PER LAYER-->
                        <div class="row justify-content-md-center">
                            <div class="col-10">
                                <!-- LAYERS TO CONNECT & DESIGN DIRECTION -->
                                @if (historyService.logicalTopology?.layersModeEnabled) {
                                    <div class="form-group">
                                        <div class="row">
                                            <span class="col-6 col-form-label-sm"> Design direction </span>
                                            <div class="col-6">
                                                <select
                                                    (change)="
                                                        changeDesignDirection(
                                                            'autodesignP2mpPerLayer',
                                                            p2mpSelectedLayer,
                                                            p2mpDesignDirection
                                                        )
                                                    "
                                                    [(ngModel)]="p2mpDesignDirection[p2mpSelectedLayer]"
                                                    [disabled]="!historyService.isEditModeEnabled"
                                                    class="form-control form-control-sm"
                                                    id="p2mp_design_direction_{{ p2mpSelectedLayer }}"
                                                    name="p2mp_design_direction_{{ p2mpSelectedLayer }}"
                                                >
                                                    <option [ngValue]="true">Bottom-up</option>
                                                    <option [ngValue]="false">Top-down</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <span class="col-6 col-form-label-sm">Layers to connect</span>
                                            <div class="col-6">
                                                <winde-multi-select
                                                    (selectedListChange)="saveP2MpConnectedLayersToTopology($event, p2mpSelectedLayer)"
                                                    [availableList]="historyService.logicalTopology.layers"
                                                    [disabled]="!historyService.isEditModeEnabled"
                                                    [displayName]="'layerFullName'"
                                                    [preselectedDisabledItems]="[
                                                        historyService.logicalTopology.layers[p2mpSelectedLayer].getFullName()
                                                    ]"
                                                    [selectedList]="autodesignP2mpLayersPerLayerString[p2mpSelectedLayer]"
                                                ></winde-multi-select>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div class="form-group">
                                    @if (editForm) {
                                        <!-- Resiliency-->
                                        <div class="row">
                                            <div class="col-6 col-form-label-sm">Resiliency</div>
                                            <div class="col-6 resiliency-col">
                                                <input
                                                    (change)="onResiliencyEnabledChange($event.target['checked'], p2mpSelectedLayer)"
                                                    [checked]="resiliencyEnabled[p2mpSelectedLayer]"
                                                    [disabled]="
                                                        !historyService.isEditModeEnabled || !layerContainsMhTgBu[p2mpSelectedLayer]
                                                    "
                                                    class="form-control form-control-sm"
                                                    id="resiliency_enabled"
                                                    name="resiliency_enabled"
                                                    type="checkbox"
                                                />
                                            </div>
                                        </div>
                                        <!--  Max PtMP devices per location -->
                                        @if (!layerContainsMhTgBu[p2mpSelectedLayer]) {
                                            <div class="row">
                                                <span class="col-6 col-form-label-sm"> Max PtMP devices per location </span>
                                                <div class="col-6">
                                                    <winde-reactive-input
                                                        [form]="editForm"
                                                        [input]="maxDevNumPerLayer[p2mpSelectedLayer]"
                                                    ></winde-reactive-input>
                                                </div>
                                            </div>
                                        }
                                        <!--  PoP Distance Factor -->
                                        <div class="row">
                                            <span class="form-label col-6 col-form-label-sm">
                                                Hop count factor
                                                <small class="text-muted"
                                                    >({{ popDistFacPerLayer[p2mpSelectedLayer].min }}-{{
                                                        popDistFacPerLayer[p2mpSelectedLayer].max
                                                    }})
                                                </small>
                                            </span>
                                            <div class="col-6">
                                                <winde-reactive-input
                                                    [form]="editForm"
                                                    [input]="popDistFacPerLayer[p2mpSelectedLayer]"
                                                ></winde-reactive-input>
                                            </div>
                                        </div>
                                        <!--  Sector assign mode -->
                                        @if (!layerContainsMhTgBu[p2mpSelectedLayer]) {
                                            <div class="row">
                                                <span class="col-6 col-form-label-sm"> Sector assign mode </span>
                                                <div class="col-6">
                                                    <winde-reactive-input
                                                        [form]="editForm"
                                                        [input]="asMethodPerLayer[p2mpSelectedLayer]"
                                                    ></winde-reactive-input>
                                                </div>
                                            </div>
                                        }
                                        @if (!layerContainsMhTgBu[p2mpSelectedLayer]) {
                                            <div [hidden]="true" class="row">
                                                <span class="col-6 col-form-label-sm"> P2P distance factor </span>
                                                <div class="col-6">
                                                    <winde-reactive-input
                                                        [form]="editForm"
                                                        [input]="p2pDistFacPerLayer[p2mpSelectedLayer]"
                                                    ></winde-reactive-input>
                                                </div>
                                            </div>
                                        }
                                    }
                                    <!--  Device number factor -->
                                    @if (!layerContainsMhTgBu[p2mpSelectedLayer]) {
                                        <div class="row">
                                            <span class="col-6 col-form-label-sm">
                                                Device number factor <small class="text-muted">(1-2)</small>
                                            </span>
                                            <div class="col-6">
                                                <input
                                                    [(inputVal)]="
                                                        historyService.logicalTopology.autodesignP2mpPerLayer[p2mpSelectedLayer].num_dev_fac
                                                    "
                                                    [(ngModel)]="
                                                        historyService.logicalTopology.autodesignP2mpPerLayer[p2mpSelectedLayer].num_dev_fac
                                                    "
                                                    [decimal]="2"
                                                    [disabled]="!historyService.isEditModeEnabled"
                                                    [showValidationText]="showFormValidationAlert"
                                                    class="form-control form-control-sm"
                                                    id="num_dev_fac_{{ p2mpSelectedLayer }}"
                                                    max="2"
                                                    min="1"
                                                    name="num_dev_fac_{{ p2mpSelectedLayer }}"
                                                    step="0.01"
                                                    type="number"
                                                    windeNumberInputValidation
                                                />
                                            </div>
                                        </div>
                                    }
                                    <!--  Uniqueness factor -->
                                    @if (!layerContainsMhTgBu[p2mpSelectedLayer]) {
                                        <div class="row">
                                            <span class="col-6 col-form-label-sm">
                                                Uniqueness factor <small class="text-muted">(3-10)</small>
                                            </span>
                                            <div class="col-6">
                                                <input
                                                    [(inputVal)]="
                                                        historyService.logicalTopology.autodesignP2mpPerLayer[p2mpSelectedLayer].rand_fac
                                                    "
                                                    [(ngModel)]="
                                                        historyService.logicalTopology.autodesignP2mpPerLayer[p2mpSelectedLayer].rand_fac
                                                    "
                                                    [decimal]="2"
                                                    [disabled]="!historyService.isEditModeEnabled"
                                                    [showValidationText]="showFormValidationAlert"
                                                    class="form-control form-control-sm"
                                                    id="rand_fac_{{ p2mpSelectedLayer }}"
                                                    max="10"
                                                    min="3"
                                                    name="rand_fac_{{ p2mpSelectedLayer }}"
                                                    step="0.01"
                                                    type="number"
                                                    windeNumberInputValidation
                                                />
                                            </div>
                                        </div>
                                    }
                                    <!--  Prefer forced BU -->
                                    @if (!layerContainsMhTgBu[p2mpSelectedLayer]) {
                                        <div class="row">
                                            <span class="col-6 col-form-label-sm"> Prefer forced BU </span>
                                            <div class="col-6">
                                                <input
                                                    (change)="
                                                        historyService.logicalTopology.autodesignP2mpPerLayer[
                                                            p2mpSelectedLayer
                                                        ].pref_forced =
                                                            !historyService.logicalTopology.autodesignP2mpPerLayer[p2mpSelectedLayer]
                                                                .pref_forced
                                                    "
                                                    [checked]="
                                                        historyService.logicalTopology.autodesignP2mpPerLayer[p2mpSelectedLayer].pref_forced
                                                    "
                                                    [disabled]="!historyService.isEditModeEnabled"
                                                    class="form-control form-control-sm ml-1"
                                                    id="pref_forced_by_p2mp_{{ p2mpSelectedLayer }}"
                                                    name="feed_sector_by_p2mp_{{ p2mpSelectedLayer }}"
                                                    type="checkbox"
                                                />
                                            </div>
                                        </div>
                                    }
                                    <!--Optional BS factor-->
                                    @if (!layerContainsMhTgBu[p2mpSelectedLayer] && editForm) {
                                        <div class="row">
                                            <span class="col-6 col-form-label-sm">
                                                Optional BU factor
                                                <small class="text-muted"
                                                    >({{ optBsFacPerLayer[p2mpSelectedLayer].min }} -{{
                                                        optBsFacPerLayer[p2mpSelectedLayer].max
                                                    }})
                                                </small>
                                            </span>
                                            <div class="col-6">
                                                <winde-reactive-input
                                                    [form]="editForm"
                                                    [input]="optBsFacPerLayer[p2mpSelectedLayer]"
                                                ></winde-reactive-input>
                                            </div>
                                        </div>
                                    }
                                    @if (!layerContainsMhTgBu[p2mpSelectedLayer]) {
                                        <div class="row">
                                            <span class="col-6 col-form-label-sm"> Allow reverse feed </span>
                                            <div class="col-1">
                                                <input
                                                    (change)="
                                                        historyService.logicalTopology.autodesignP2mpPerLayer[
                                                            p2mpSelectedLayer
                                                        ].triggerReverseFeedCheck()
                                                    "
                                                    [checked]="
                                                        historyService.logicalTopology.autodesignP2mpPerLayer[p2mpSelectedLayer]
                                                            .rev_feed_fac === -1
                                                    "
                                                    [disabled]="!historyService.isEditModeEnabled"
                                                    class="form-control form-control-sm"
                                                    id="rev_feed_fac_check"
                                                    name="feed_sector_by_p2mp"
                                                    type="checkbox"
                                                />
                                            </div>
                                            <div class="col-5">
                                                @if (
                                                    historyService.logicalTopology.autodesignP2mpPerLayer[p2mpSelectedLayer]
                                                        .rev_feed_fac !== -1
                                                ) {
                                                    <input
                                                        [(inputVal)]="
                                                            historyService.logicalTopology.autodesignP2mpPerLayer[p2mpSelectedLayer]
                                                                .rev_feed_fac
                                                        "
                                                        [(ngModel)]="
                                                            historyService.logicalTopology.autodesignP2mpPerLayer[p2mpSelectedLayer]
                                                                .rev_feed_fac
                                                        "
                                                        [decimal]="2"
                                                        [disabled]="!historyService.isEditModeEnabled"
                                                        [showValidationText]="showFormValidationAlert"
                                                        class="form-control form-control-sm"
                                                        id="rev_feed_fac_{{ p2mpSelectedLayer }}"
                                                        max="10"
                                                        min="1"
                                                        name="rev_feed_fac_{{ p2mpSelectedLayer }}"
                                                        step="0.01"
                                                        type="number"
                                                        windeNumberInputValidation
                                                    />
                                                }
                                            </div>
                                        </div>
                                    }
                                    <div class="row">
                                        <span class="col-6 col-form-label-sm"> Global "BU must" devices azimuth </span>
                                        <div class="col-6">
                                            <input
                                                [(inputVal)]="
                                                    historyService.logicalTopology.autodesignP2mpPerLayer[p2mpSelectedLayer].buDeviceAzimuth
                                                "
                                                [(ngModel)]="
                                                    historyService.logicalTopology.autodesignP2mpPerLayer[p2mpSelectedLayer].buDeviceAzimuth
                                                "
                                                [disabled]="!historyService.isEditModeEnabled"
                                                [showValidationText]="showFormValidationAlert"
                                                class="form-control form-control-sm"
                                                id="bu_device_azimuth_{{ p2mpSelectedLayer }}"
                                                max="359"
                                                min="0"
                                                name="bu_device_azimuth_{{ p2mpSelectedLayer }}"
                                                step="1"
                                                type="number"
                                                windeNumberInputValidation
                                            />
                                        </div>
                                    </div>
                                    @if (editForm) {
                                        <div class="row">
                                            <span class="col-6 col-form-label-sm">
                                                Capacity factor
                                                <small class="text-muted"
                                                    >({{ capFacPerLayer[p2mpSelectedLayer].min }} -{{
                                                        capFacPerLayer[p2mpSelectedLayer].max
                                                    }})
                                                </small>
                                            </span>
                                            <div class="col-6">
                                                <winde-reactive-input
                                                    [form]="editForm"
                                                    [input]="capFacPerLayer[p2mpSelectedLayer]"
                                                ></winde-reactive-input>
                                            </div>
                                        </div>
                                        @if (!layerContainsMhTgBu[p2mpSelectedLayer]) {
                                            <div [hidden]="true" class="row">
                                                <span class="col-6 col-form-label-sm">
                                                    Cost factor
                                                    <small class="text-muted"
                                                        >({{ costFacPerLayer[p2mpSelectedLayer].min }} -{{
                                                            costFacPerLayer[p2mpSelectedLayer].max
                                                        }})
                                                    </small>
                                                </span>
                                                <div class="col-6">
                                                    <winde-reactive-input
                                                        [form]="editForm"
                                                        [input]="costFacPerLayer[p2mpSelectedLayer]"
                                                    ></winde-reactive-input>
                                                </div>
                                            </div>
                                        }
                                        <div class="form-group row justify-content-md-center">
                                            <span class="col-6 col-form-label-sm">
                                                Max azimuth in sector
                                                <small class="text-muted"
                                                    >({{ lcentDistPerLayer[p2mpSelectedLayer].min }}-{{
                                                        lcentDistPerLayer[p2mpSelectedLayer].max
                                                    }})
                                                </small>
                                            </span>
                                            <div class="col-6">
                                                <winde-reactive-input
                                                    [form]="editForm"
                                                    [input]="lcentDistPerLayer[p2mpSelectedLayer]"
                                                ></winde-reactive-input>
                                            </div>
                                        </div>
                                        <div [hidden]="true" class="form-group row justify-content-md-center">
                                            <span class="col-6 col-form-label-sm">
                                                Take rate
                                                <small class="text-muted"
                                                    >({{ takeRatePerLayer[p2mpSelectedLayer].min }}-{{
                                                        takeRatePerLayer[p2mpSelectedLayer].max
                                                    }})
                                                </small>
                                            </span>
                                            <div class="col-6">
                                                <winde-reactive-input
                                                    [form]="editForm"
                                                    [input]="takeRatePerLayer[p2mpSelectedLayer]"
                                                ></winde-reactive-input>
                                            </div>
                                        </div>
                                        @if (!layerContainsMhTgBu[p2mpSelectedLayer]) {
                                            <div class="form-group row justify-content-md-center">
                                                <span class="col-6 col-form-label-sm mb-0"> Limit on boxes </span>
                                                <div class="col-6">
                                                    <winde-reactive-input
                                                        [form]="editForm"
                                                        [input]="limBoxesPerLayer[p2mpSelectedLayer]"
                                                    ></winde-reactive-input>
                                                </div>
                                            </div>
                                        }
                                        @if (!layerContainsMhTgBu[p2mpSelectedLayer]) {
                                            <div [hidden]="true" class="form-group row justify-content-md-center">
                                                <span class="col-6 col-form-label-sm">
                                                    N candidate window
                                                    <small class="text-muted"
                                                        >({{ nCandWinPerLayer[p2mpSelectedLayer].min }}-{{
                                                            nCandWinPerLayer[p2mpSelectedLayer].max
                                                        }})
                                                    </small>
                                                </span>
                                                <div class="col-6">
                                                    <winde-reactive-input
                                                        [form]="editForm"
                                                        [input]="nCandWinPerLayer[p2mpSelectedLayer]"
                                                    ></winde-reactive-input>
                                                </div>
                                            </div>
                                        }
                                        @if (!layerContainsMhTgBu[p2mpSelectedLayer]) {
                                            <div [hidden]="true" class="form-group row justify-content-md-center">
                                                <span class="col-6 col-form-label-sm">
                                                    Max. iterations
                                                    <small class="text-muted"
                                                        >({{ tgMaxIttrPerLayer[p2mpSelectedLayer].min }}-{{
                                                            tgMaxIttrPerLayer[p2mpSelectedLayer].max
                                                        }})
                                                    </small>
                                                </span>
                                                <div class="col-6">
                                                    <winde-reactive-input
                                                        [form]="editForm"
                                                        [input]="tgMaxIttrPerLayer[p2mpSelectedLayer]"
                                                    ></winde-reactive-input>
                                                </div>
                                            </div>
                                        }
                                        @if (resiliencyEnabled[p2mpSelectedLayer]) {
                                            <div class="form-group row justify-content-md-center">
                                                <span class="col-6 col-form-label-sm">
                                                    Connected factor
                                                    <small class="text-muted"
                                                        >({{ peerBsFacPerLayer[p2mpSelectedLayer].min }}-{{
                                                            peerBsFacPerLayer[p2mpSelectedLayer].max
                                                        }})
                                                    </small>
                                                </span>
                                                <div class="col-6">
                                                    <winde-reactive-input
                                                        [form]="editForm"
                                                        [input]="peerBsFacPerLayer[p2mpSelectedLayer]"
                                                    ></winde-reactive-input>
                                                </div>
                                            </div>
                                        }
                                        @if (resiliencyEnabled[p2mpSelectedLayer]) {
                                            <div class="form-group row justify-content-md-center">
                                                <span class="col-6 col-form-label-sm">
                                                    Resiliency factor
                                                    <small class="text-muted"
                                                        >({{ redunFacPerLayer[p2mpSelectedLayer].min }}-{{
                                                            redunFacPerLayer[p2mpSelectedLayer].max
                                                        }})
                                                    </small>
                                                </span>
                                                <div class="col-6">
                                                    <winde-reactive-input
                                                        [form]="editForm"
                                                        [input]="redunFacPerLayer[p2mpSelectedLayer]"
                                                    ></winde-reactive-input>
                                                </div>
                                            </div>
                                        }
                                        @if (resiliencyEnabled[p2mpSelectedLayer]) {
                                            <div class="form-group row justify-content-md-center">
                                                <span class="col-6 col-form-label-sm">
                                                    Tunnel factor
                                                    <small class="text-muted"
                                                        >({{ tunnelFacPerLayer[p2mpSelectedLayer].min }}-{{
                                                            tunnelFacPerLayer[p2mpSelectedLayer].max
                                                        }})
                                                    </small>
                                                </span>
                                                <div class="col-6">
                                                    <winde-reactive-input
                                                        [form]="editForm"
                                                        [input]="tunnelFacPerLayer[p2mpSelectedLayer]"
                                                    ></winde-reactive-input>
                                                </div>
                                            </div>
                                        }
                                    }
                                </div>
                            </div>
                        </div>
                        @if (historyService.logicalTopology.layersModeEnabled) {
                            <div class="row justify-content-md-center align-items-center">
                                <div class="col-5 col-form-label-sm">
                                    <button
                                        (click)="copyDesignSettingsFromLayer(currentTab)"
                                        [disabled]="!historyService.isEditModeEnabled"
                                        class="btn btn-link btn-sm btn-copy-p2mp px-0"
                                        id="copy-p2mp-btn_{{ p2mpSelectedLayer }}"
                                    >
                                        {{ 'project.manualDesign.copyDesignSettingsFrom' | translate }}
                                    </button>
                                </div>
                                <div class="col-5">
                                    <select
                                        [(ngModel)]="copyP2mpConfigFromLayer"
                                        [disabled]="!historyService.isEditModeEnabled"
                                        class="form-control form-control-sm"
                                        id="layer_to_copy_p2mp_from_{{ p2mpSelectedLayer }}"
                                        name="layer_to_copy_p2mp_from_{{ p2mpSelectedLayer }}"
                                    >
                                        @for (layerToCopyFrom of historyService.logicalTopology.layers; track layerToCopyFrom) {
                                            <option [ngValue]="layerToCopyFrom.layerIndex">
                                                {{ layerToCopyFrom.getFullName() }}
                                            </option>
                                        }
                                    </select>
                                </div>
                            </div>
                        }
                    </div>
                }

                @if (currentTab === manualDesignSteps.DESIGN_RINGS) {
                    <div class="tab-pane active" role="tabpanel">
                        <div class="clr">
                            <div class="form-group row justify-content-md-center">
                                @if (historyService.logicalTopology?.layersModeEnabled) {
                                    <div class="col-5">
                                        <div class="d-inline-flex align-middle">
                                            <button
                                                (click)="designRings()"
                                                [disabled]="!historyService.isEditModeEnabled"
                                                class="btn btn-sm btn-success btn-small-style btn-design-rings"
                                            >
                                                {{ 'project.manualDesignSteps.runDesignRings' | translate }}
                                            </button>
                                            <span class="layer-label-text">for layer</span>
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <select
                                            [(ngModel)]="ringsSelectedLayer"
                                            [disabled]="!historyService.isEditModeEnabled"
                                            class="form-control form-control-sm"
                                            id="ring_selected_layer"
                                            name="ring_selected_layer"
                                        >
                                            @for (layer of historyService.logicalTopology.layers; track layer) {
                                                <option [ngValue]="layer.layerIndex">
                                                    {{ layer.getFullName() }}
                                                </option>
                                            }
                                        </select>
                                    </div>
                                }
                                @if (!historyService.logicalTopology?.layersModeEnabled) {
                                    <div class="col-10">
                                        <button
                                            (click)="designRings()"
                                            [disabled]="!historyService.isEditModeEnabled"
                                            class="btn btn-sm btn-success btn-small-style btn-design-rings"
                                        >
                                            {{ 'project.manualDesignSteps.runDesignRings' | translate }}
                                        </button>
                                    </div>
                                }
                            </div>
                            @if (historyService.logicalTopology?.layersModeEnabled) {
                                <hr />
                            }
                        </div>
                        <!--DESIGN RINGS PER LAYER-->
                        @if (historyService.logicalTopology.designRingsPerLayer[ringsSelectedLayer]) {
                            <div>
                                @for (
                                    designRingsPerLayer of historyService.logicalTopology.designRingsPerLayer;
                                    track designRingsPerLayer;
                                    let layerIndex = $index
                                ) {
                                    @if (
                                        (historyService.logicalTopology?.layersModeEnabled && layerIndex === ringsSelectedLayer) ||
                                        (!historyService.logicalTopology?.layersModeEnabled && layerIndex === 0)
                                    ) {
                                        <!-- LAYERS TO CONNECT & DESIGN DIRECTION -->
                                        @if (historyService.logicalTopology?.layersModeEnabled) {
                                            <div class="form-group row justify-content-md-center">
                                                <div class="col-10">
                                                    <div class="row">
                                                        <span class="col-6 col-form-label-sm"> Design direction </span>
                                                        <div class="col-6">
                                                            <select
                                                                (change)="
                                                                    changeDesignDirection(
                                                                        'designRingsPerLayer',
                                                                        layerIndex,
                                                                        ringsDesignDirection
                                                                    )
                                                                "
                                                                [(ngModel)]="ringsDesignDirection[layerIndex]"
                                                                [disabled]="!historyService.isEditModeEnabled"
                                                                class="form-control form-control-sm"
                                                                id="rings_design_direction_{{ layerIndex }}"
                                                                name="rings_design_direction_{{ layerIndex }}"
                                                            >
                                                                <option [ngValue]="true">Bottom-up</option>
                                                                <option [ngValue]="false">Top-down</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <span class="col-6 col-form-label-sm">Layers to connect</span>
                                                        <div class="col-6">
                                                            <winde-multi-select
                                                                (selectedListChange)="
                                                                    saveRingsConnectedLayersToTopology($event, layerIndex)
                                                                "
                                                                [availableList]="historyService.logicalTopology.layers"
                                                                [disabled]="!historyService.isEditModeEnabled"
                                                                [displayName]="'layerFullName'"
                                                                [preselectedDisabledItems]="[
                                                                    historyService.logicalTopology.layers[layerIndex].getFullName()
                                                                ]"
                                                                [selectedList]="designRingsLayersPerLayerString[layerIndex]"
                                                            ></winde-multi-select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <!-- Redundancy-->
                                        <div class="form-group row justify-content-md-center">
                                            <div class="col-10">
                                                <div class="row">
                                                    <div class="col-6 col-form-label-sm">Redundancy required</div>
                                                    <div class="col-6 redundancy-col">
                                                        <input
                                                            (change)="setRedundancyEnabled(layerIndex, $event.target['checked'])"
                                                            [checked]="redundancyEnabled[layerIndex]"
                                                            [disabled]="!historyService.isEditModeEnabled"
                                                            class="form-control form-control-sm"
                                                            id="redundancy_required"
                                                            name="redundancy_required"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        @if (redundancyEnabled[layerIndex]) {
                                            <div class="form-group row justify-content-md-center">
                                                <div class="col-10">
                                                    <div class="row margin-bottom-10">
                                                        <div class="col-6 col-form-label-sm">Redundant links, count</div>
                                                        <div class="col-6">
                                                            <input
                                                                (ngModelChange)="
                                                                    calculateRedundancy(layerIndex, designRingsPerLayer.rsz_th)
                                                                "
                                                                [(inputVal)]="designRingsPerLayer.rsz_th"
                                                                [(ngModel)]="designRingsPerLayer.rsz_th"
                                                                [disabled]="!historyService.isEditModeEnabled"
                                                                [max]="nodesCountPerLayer[layerIndex]"
                                                                [showValidationText]="showFormValidationAlert"
                                                                class="form-control form-control-sm"
                                                                min="1"
                                                                name="rsz_th"
                                                                type="number"
                                                                windeNumberInputValidation
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="row margin-bottom-10">
                                                        <div class="col-6 col-form-label-sm">Redundant links, %</div>
                                                        <div class="col-6">
                                                            <input
                                                                (ngModelChange)="
                                                                    calculateRedundancy(layerIndex, redundancyPercent[layerIndex], true)
                                                                "
                                                                [(inputVal)]="redundancyPercent[layerIndex]"
                                                                [(ngModel)]="redundancyPercent[layerIndex]"
                                                                [decimal]="1"
                                                                [disabled]="!historyService.isEditModeEnabled"
                                                                [showValidationText]="showFormValidationAlert"
                                                                class="form-control form-control-sm"
                                                                max="100"
                                                                min="1"
                                                                name="redundancyPercent"
                                                                step="0.1"
                                                                type="number"
                                                                windeNumberInputValidation
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="row margin-bottom-10">
                                                        <div class="col-6 col-form-label-sm">Weight (0-1)</div>
                                                        <div class="col-6">
                                                            <input
                                                                [(inputVal)]="designRingsPerLayer.rsz_weig"
                                                                [(ngModel)]="designRingsPerLayer.rsz_weig"
                                                                [decimal]="2"
                                                                [disabled]="!historyService.isEditModeEnabled"
                                                                [showValidationText]="showFormValidationAlert"
                                                                class="form-control form-control-sm"
                                                                max="1"
                                                                min="0"
                                                                name="rsz_weig"
                                                                step="0.01"
                                                                type="number"
                                                                windeNumberInputValidation
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <!-- Radios per Location-->
                                        <div class="form-group row justify-content-md-center form-group--link_per_node_const">
                                            <div class="col-10">
                                                <div class="row margin-bottom-10">
                                                    <div class="col-6 col-form-label-sm">Radios per Location Factor</div>
                                                    <div class="col-6">
                                                        <input
                                                            [(inputVal)]="designRingsPerLayer.lpn_fac"
                                                            [(ngModel)]="designRingsPerLayer.lpn_fac"
                                                            [disabled]="!historyService.isEditModeEnabled"
                                                            [showValidationText]="showFormValidationAlert"
                                                            class="form-control form-control-sm"
                                                            min="0"
                                                            name="lpn_fac"
                                                            type="number"
                                                            windeNumberInputValidation
                                                        />
                                                    </div>
                                                </div>
                                                <div class="row margin-bottom-10">
                                                    <div class="col-6 col-form-label-sm">Radios per Location Threshold</div>
                                                    <div class="col-6">
                                                        <input
                                                            [(inputVal)]="designRingsPerLayer.lpn_th"
                                                            [(ngModel)]="designRingsPerLayer.lpn_th"
                                                            [disabled]="!historyService.isEditModeEnabled"
                                                            [showValidationText]="showFormValidationAlert"
                                                            class="form-control form-control-sm"
                                                            max="100"
                                                            min="1"
                                                            name="lpn_th"
                                                            type="number"
                                                            windeNumberInputValidation
                                                        />
                                                    </div>
                                                </div>
                                                <div class="row margin-bottom-10">
                                                    <div class="col-6 col-form-label-sm">
                                                        Radios per Location Weight <small class="text-muted">(0-1)</small>
                                                    </div>
                                                    <div class="col-6">
                                                        <input
                                                            [(inputVal)]="designRingsPerLayer.lpn_weig"
                                                            [(ngModel)]="designRingsPerLayer.lpn_weig"
                                                            [decimal]="2"
                                                            [disabled]="!historyService.isEditModeEnabled"
                                                            [showValidationText]="showFormValidationAlert"
                                                            class="form-control form-control-sm"
                                                            max="1"
                                                            min="0"
                                                            name="lpn_weig"
                                                            step="0.01"
                                                            type="number"
                                                            windeNumberInputValidation
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Hop Count-->
                                        <div class="form-group row justify-content-md-center form-group--number_of_hops_const">
                                            <div class="col-10">
                                                <div class="row margin-bottom-10">
                                                    <div class="col-6 col-form-label-sm">Hop Count Factor</div>
                                                    <div class="col-6">
                                                        <input
                                                            [(inputVal)]="designRingsPerLayer.noh_fac"
                                                            [(ngModel)]="designRingsPerLayer.noh_fac"
                                                            [disabled]="!historyService.isEditModeEnabled"
                                                            [showValidationText]="showFormValidationAlert"
                                                            class="form-control form-control-sm"
                                                            min="0"
                                                            name="noh_fac"
                                                            type="number"
                                                            windeNumberInputValidation
                                                        />
                                                    </div>
                                                </div>
                                                <div class="row margin-bottom-10">
                                                    <div class="col-6 col-form-label-sm">Hop Count Threshold</div>
                                                    <div class="col-6">
                                                        <input
                                                            [(inputVal)]="designRingsPerLayer.noh_th"
                                                            [(ngModel)]="designRingsPerLayer.noh_th"
                                                            [disabled]="!historyService.isEditModeEnabled"
                                                            [showValidationText]="showFormValidationAlert"
                                                            class="form-control form-control-sm"
                                                            max="{{ totalNumberOfNodes }}"
                                                            min="0"
                                                            name="noh_th"
                                                            type="number"
                                                            windeNumberInputValidation
                                                        />
                                                    </div>
                                                </div>
                                                <div class="row margin-bottom-10">
                                                    <div class="col-6 col-form-label-sm">
                                                        Hop Count Weight <small class="text-muted">(0-1)</small>
                                                    </div>
                                                    <div class="col-6">
                                                        <input
                                                            [(inputVal)]="designRingsPerLayer.noh_weig"
                                                            [(ngModel)]="designRingsPerLayer.noh_weig"
                                                            [decimal]="2"
                                                            [disabled]="!historyService.isEditModeEnabled"
                                                            [showValidationText]="showFormValidationAlert"
                                                            class="form-control form-control-sm"
                                                            max="1"
                                                            min="0"
                                                            name="noh_weig"
                                                            step="0.01"
                                                            type="number"
                                                            windeNumberInputValidation
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row justify-content-md-center">
                                            <span class="col-5 col-form-label-sm">Optional locations constraint</span>
                                            <div class="col-5">
                                                <input
                                                    [(inputVal)]="designRingsPerLayer.opn_weig"
                                                    [(ngModel)]="designRingsPerLayer.opn_weig"
                                                    [decimal]="2"
                                                    [disabled]="!historyService.isEditModeEnabled"
                                                    [showValidationText]="showFormValidationAlert"
                                                    class="form-control form-control-sm"
                                                    id="opn_weig"
                                                    max="1"
                                                    min="0"
                                                    name="opn_weig"
                                                    step="0.01"
                                                    type="number"
                                                    windeNumberInputValidation
                                                />
                                            </div>
                                        </div>
                                    }
                                }
                                @if (historyService.logicalTopology?.layersModeEnabled) {
                                    <div class="row justify-content-md-center align-items-center">
                                        <div class="col-5 col-form-label-sm">
                                            <button
                                                (click)="copyDesignSettingsFromLayer(currentTab)"
                                                [disabled]="!historyService.isEditModeEnabled"
                                                class="btn btn-link btn-sm btn-copy-rings px-0"
                                                id="copy-rings-btn_{{ ringsSelectedLayer }}"
                                            >
                                                {{ 'project.manualDesign.copyDesignSettingsFrom' | translate }}
                                            </button>
                                        </div>
                                        <div class="col-5">
                                            <select
                                                [(ngModel)]="copyRingsConfigFromLayer"
                                                [disabled]="!historyService.isEditModeEnabled"
                                                class="form-control form-control-sm"
                                                id="layer_to_copy_rings_from_{{ ringsSelectedLayer }}"
                                                name="layer_to_copy_rings_from_{{ ringsSelectedLayer }}"
                                            >
                                                @for (layerToCopyFrom of historyService.logicalTopology.layers; track layerToCopyFrom) {
                                                    <option [ngValue]="layerToCopyFrom.layerIndex">
                                                        {{ layerToCopyFrom.getFullName() }}
                                                    </option>
                                                }
                                            </select>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }

                <!--AUTO SET FREQUENCIES-->
                @if (currentTab === manualDesignSteps.AUTO_SET_FREQUENCIES) {
                    <div class="tab-pane active" role="tabpanel">
                        @if (historyService.logicalTopology.autoSetFrequenciesPerLayer[frequenciesDefaultLayer]) {
                            <section>
                                <div class="form-group row justify-content-md-center">
                                    <div class="form-group col-12 m-0">
                                        <div class="d-inline-flex align-items-baseline">
                                            <span class="btn-inline-text">Run</span>
                                            <button
                                                (click)="autoSelectFrequencies()"
                                                [disabled]="!historyService.isEditModeEnabled"
                                                class="btn btn-sm btn-success btn-small-style btn-select-frequencies"
                                            >
                                                {{ 'project.manualDesignSteps.autoSelectFrequencies' | translate }}
                                            </button>
                                            <span class="btn-inline-text">and</span>
                                            <button
                                                (click)="autoConfigureRings()"
                                                [disabled]="!historyService.isEditModeEnabled"
                                                class="btn btn-sm btn-success btn-small-style btn-configure-rings"
                                            >
                                                {{ 'project.manualDesignSteps.runAutoConfigureRings' | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <!-- Interference Analysis-->
                                <div class="row justify-content-md-center form-group--analysis_value">
                                    <div class="col-10">
                                        <div class="row margin-bottom-10">
                                            <span class="col-6">Interference Analysis</span>
                                            <div class="col-6">
                                                <span class="d-block">
                                                    <input
                                                        (ngModelChange)="onWorstCaseChange($event)"
                                                        [(ngModel)]="
                                                            historyService.logicalTopology.autoSetFrequenciesPerLayer[
                                                                frequenciesDefaultLayer
                                                            ].wc_analysis
                                                        "
                                                        [attr.data-value]="false"
                                                        [disabled]="!historyService.isEditModeEnabled"
                                                        [value]="false"
                                                        class="form-control inp-inline form-group--analysis_value--nominal-analysis analysis_value"
                                                        name="analysis_value_nominal"
                                                        type="radio"
                                                    />
                                                    Optimal
                                                </span>
                                                <span class="d-block">
                                                    <input
                                                        (ngModelChange)="onWorstCaseChange($event)"
                                                        [(ngModel)]="
                                                            historyService.logicalTopology.autoSetFrequenciesPerLayer[
                                                                frequenciesDefaultLayer
                                                            ].wc_analysis
                                                        "
                                                        [attr.data-value]="true"
                                                        [disabled]="!historyService.isEditModeEnabled"
                                                        [value]="true"
                                                        class="form-control inp-inline form-group--analysis_value--worst-case-analysis"
                                                        name="analysis_value_worst-case"
                                                        type="radio"
                                                    />
                                                    Worst Case
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Radio position variance-->
                                <div class="form-group row justify-content-md-center">
                                    <span class="col-5 col-form-label-sm">Radio position variance</span>
                                    <div class="col-5">
                                        <input
                                            [(inputVal)]="
                                                historyService.logicalTopology.autoSetFrequenciesPerLayer[frequenciesDefaultLayer]
                                                    .pos_accuracy
                                            "
                                            [(ngModel)]="
                                                historyService.logicalTopology.autoSetFrequenciesPerLayer[frequenciesDefaultLayer]
                                                    .pos_accuracy
                                            "
                                            [disabled]="
                                                !historyService.isEditModeEnabled ||
                                                !historyService.logicalTopology.autoSetFrequenciesPerLayer[frequenciesDefaultLayer]
                                                    .wc_analysis
                                            "
                                            [showValidationText]="showFormValidationAlert"
                                            class="form-control form-control-sm"
                                            id="link_position"
                                            min="0"
                                            name="link_position"
                                            type="number"
                                            windeNumberInputValidation
                                        />
                                    </div>
                                </div>
                                <!-- Polarization or Frequency-->
                                <div class="form-group row justify-content-md-center form-group--polarization_value">
                                    <div class="col-10">
                                        <div class="row margin-bottom-10">
                                            <span class="col-6">Polarization or Frequency</span>
                                            <div class="col-6 form-group--use_min">
                                                <span class="d-block">
                                                    <input
                                                        [(ngModel)]="
                                                            historyService.logicalTopology.autoSetFrequenciesPerLayer[
                                                                frequenciesDefaultLayer
                                                            ].pol_priority
                                                        "
                                                        [attr.data-value]="true"
                                                        [disabled]="!historyService.isEditModeEnabled"
                                                        [value]="true"
                                                        class="form-control inp-inline form-group--use_min--polarizations"
                                                        name="use_min--polarizations"
                                                        type="radio"
                                                    />
                                                    Polarizations
                                                </span>
                                                <span class="d-block">
                                                    <input
                                                        [(ngModel)]="
                                                            historyService.logicalTopology.autoSetFrequenciesPerLayer[
                                                                frequenciesDefaultLayer
                                                            ].pol_priority
                                                        "
                                                        [attr.data-value]="false"
                                                        [disabled]="!historyService.isEditModeEnabled"
                                                        [value]="false"
                                                        class="form-control inp-inline form-group--use_min--frequencies"
                                                        name="use_min--frequencies"
                                                        type="radio"
                                                    />
                                                    Frequencies
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
</div>
